import { ActiveModel, ActiveField } from '@alt-point/active-models/src'

/**
* Class CdekEstimatedIntervalsRequestQuery
*  Query params for operation "CdekEstimatedIntervals"
*/
export class CdekEstimatedIntervalsRequestQuery extends ActiveModel {

  /**
  * CityCode
  * Код города СДЭК получателя.  */
  @ActiveField()
  CityCode?: number


/**
  * Address
  * Адрес (не обязателен для списка окон).
  */
  @ActiveField()
  Address?: string


/**
  * PostalCode
  * Почтовый индекс.
  */
  @ActiveField()
  PostalCode?: string


/**
  * CountryCode
  * Код страны ISO.
  */
  @ActiveField()
  CountryCode?: string


/**
  * City
  * Название города.
  */
  @ActiveField()
  City?: string
}
